// removed by extract-text-webpack-plugin
module.exports = {"Welcome":"Home__Welcome__3kdDL","Categories":"Home__Categories__3SKPY","LogoContainer":"Home__LogoContainer__11hin","Hidden":"Home__Hidden__16cNH","CategoriesMobile":"Home__CategoriesMobile__2axd7","ArrowButton":"Home__ArrowButton__3m4xX","LeftArrowButton":"Home__LeftArrowButton__3mgex","RightArrowButton":"Home__RightArrowButton__g6xQd","StoreButtonContainer":"Home__StoreButtonContainer__rBC0D","StoreButton":"Home__StoreButton__1p5lj"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/Home.css
// module id = 224
// module chunks = 0